module.exports = __webpack_public_path__ + "media/images/pic/meat-board-ebb233028fca97eda090577f3d90fc54.webp";